// DELETED

export const DELETED = 'state.actions.operations.DELETED' as const;

export type DeletedPayload = {
	name: string;
};

export type DeletedAction = {
	type: typeof DELETED;
	payload: DeletedPayload;
};

export const deleted = (name: string): DeletedAction => ({
	type: DELETED,
	payload: { name },
});

// DELETE_FAILED

export const DELETE_FAILED = 'state.actions.operations.DELETE_FAILED' as const;

export type DeleteFailedPayload = {
	name: string;
};

export type DeleteFailedAction = {
	type: typeof DELETE_FAILED;
	payload: DeleteFailedPayload;
};

export const deleteFailed = (name: string): DeleteFailedAction => ({
	type: DELETE_FAILED,
	payload: {
		name,
	},
});

// COPIED

export const COPIED = 'state.actions.operations.COPIED' as const;

type CopiedPayload = {
	id: string;
	originalItemName: string;
};

type CopiedAction = {
	type: typeof COPIED;
	payload: CopiedPayload;
};

export const copied = (payload: CopiedPayload): CopiedAction => ({
	type: COPIED,
	payload,
});

// COPY_FAILED

export const COPY_FAILED = 'state.actions.operations.COPY_FAILED' as const;

type CopyFailedPayload = string;

type CopyFailedAction = {
	type: typeof COPY_FAILED;
	payload: CopyFailedPayload;
};

export const copyFailed = (payload: CopyFailedPayload): CopyFailedAction => ({
	type: COPY_FAILED,
	payload,
});

// actions

export type Action = DeletedAction | DeleteFailedAction | CopiedAction | CopyFailedAction;
